import { loadable } from '@shared/core/loadableFromNamedExport';

export const SaveTheDateMarcomFooter = loadable(() => import(/* webpackChunkName: "card/SaveTheDateMarcomFooter" */ './SaveTheDateMarcomFooter'), 'SaveTheDateMarcomFooter');
